module.exports = __webpack_public_path__ + "static/img/card_02@2x.aedd3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_02@2x.png
// module id = A47v
// module chunks = 0